/** 对 Web Storage 的类型化同步封装，自动序列化/反序列化，读写失败静默降级 */
export function createWebStorage(storage: Storage) {
  return {
    get<T>(key: string): T | null {
      try {
        const raw = storage.getItem(key)
        return raw ? (JSON.parse(raw) as T) : null
      } catch {
        return null
      }
    },
    set<T>(key: string, value: T) {
      try {
        storage.setItem(key, JSON.stringify(value))
      } catch {
        /* 忽略容量超限 / 序列化异常 */
      }
    },
    remove(key: string) {
      try {
        storage.removeItem(key)
      } catch {
        /* noop */
      }
    },
  }
}

export const sessionStore = createWebStorage(sessionStorage)
export const localStore = createWebStorage(localStorage)
